export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <p className="font-display font-semibold text-lg">MethodA</p>
          <p className="text-sm text-muted-foreground">
            Free AI Trading Health Assessment for Indian retail traders.
          </p>
        </div>
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} MethodA. Educational content only — not financial advice.
        </p>
      </div>
    </footer>
  );
}
